import { AttachedImage } from "./attached-image.model";

export class News {
    id;
    title;
    briefly;
    content;
    visible;
    image;

    constructor() {
        this.image = new AttachedImage();
    }
}